import React, { useState } from 'react';
import { Form, Formik } from "formik";
import { Button, Row } from "reactstrap";
import moment from 'moment';
import { FormattedMessage } from "react-intl";
import { scrollToErrors } from '../../../../helpers/general';
import { CreateCampaignSchema } from '../../../../helpers/schemas';
import { CampaignInfo } from './CampaignInfo';
import { NOTIFICATION_CREATE_CAMPAIGN } from '../../../../config/notifications';
import { history } from '../../../../store/store';
import { TRACKING_OPTIONS_PLATFORMS } from "../../../../config/constants/Campaign/campaign_constants";
import { createCampaign } from "../../../../api/campaigns/campaigns";
import { addParam } from "../../../../api/helper";
import { ROUTE_CLIENT_CAMPAIGN_VIEW } from "../../../../config/routes";
import { Link } from "react-router-dom";
import { ROUTE_CLIENT_CAMPAIGN } from "../../../../config/routes";

function CreateCampaignForm(props) {
  const [ initialValues, setInitialValues ] = useState({
    name: '',
    notes: '',
    start_date: moment(),
    end_date: moment(),
    campaign_trackings: [
      {
        tracking_label: TRACKING_OPTIONS_PLATFORMS[0].value,
        tracking_id: '',
      },
    ],
  });

  const saveCampaign = (data) => {
    data.start_date = moment(data.start_date).format("yyyy-MM-DD");
    data.end_date = moment(data.end_date).format("yyyy-MM-DD");

    if (data.prefix) {
      data.prefix = data.prefix.toUpperCase();
    }

    createCampaign({ data: data, notificationId: NOTIFICATION_CREATE_CAMPAIGN }).then(response => {
      if (response && response.data && response.data.id) {

        history.push(addParam(
          ROUTE_CLIENT_CAMPAIGN_VIEW,
          {
            ":id": response.data.id,
          }
        ));
      }
    });
  }

  return (
      <Formik
        key="create_campaign"
        initialValues={ initialValues }
        validationSchema={ CreateCampaignSchema }
        validateOnChange={ true }
        enableReinitialize={ true }
        onSubmit={
          data => {
            saveCampaign(data);
          }
        }
      >
        {
          formikProps => {
            scrollToErrors(formikProps);

            return (
              <Form className="create-campaign-form">
                <CampaignInfo
                  formikProps={ formikProps }
                  initialValues={ initialValues }
                  setInitialValues={ setInitialValues }
                />
                <Row className="create-campaign-actions justify-content-end m-0">
                  <Button type="submit" color="primary">
                    <FormattedMessage id="button.save" />
                  </Button>
                  <Link className="btn btn-secondary" to={ROUTE_CLIENT_CAMPAIGN}>
                    <FormattedMessage id="messages.go_back"/>
                  </Link>
                </Row>
              </Form>
            );
          }
        }
      </Formik>
  )
}

export { CreateCampaignForm };
